<div class="raw-select container">
	<div *ngIf="allowedDates === undefined" class="text-center pt-3 pb-3">
		<div class="logo-spin light"></div>
		Loading available dates...
	</div>
	<div *ngIf="allowedDates && allowedDates.length === 0" class="pt-3 pb-3">
		No raw data available for this component
	</div>
	<div *ngIf="allowedDates && allowedDates.length > 0" class="row">
		<label class="col-sm-2 col-form-label">Date: </label>
		<div class="col-sm-4">
			<app-day-picker [(ngModel)]="selectedDate" (ngModelChange)="dateChange()" [allowedDates]="allowedDates"></app-day-picker>
		</div>
		<ng-container *ngIf="rawids && rawids.length > 0">
			<label class="col-sm-2 col-form-label">Acquisition: </label>
			<div *ngIf="rawids && rawids.length" class="col-sm-4">
				<select class="form-control form-control-sm" [ngModel]="selected" (ngModelChange)="rawChange($event)">
					<option *ngFor="let raw of rawids" [ngValue]="raw">{{raw.ts | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</option>
				</select>
			</div>
		</ng-container>
		<div *ngIf="rawids === undefined" class="col-sm-6 col-form-label">
			Loading acquisitions...
		</div>
		<div *ngIf="rawids && rawids.length === 0" class="col-sm-6 col-form-label">
			No acquisitions available
		</div>
	</div>
</div>